<template>
    <div class="speed-data-section">
        <!-- 模块标题 -->
        <h3>3.3、发动机负荷率</h3>
        <!-- ECharts 柱状图容器 -->
        <div style="margin-top: 15px;">
            <el-row :gutter="20">
                <!-- 第一个饼图：工作/非工作区域 -->
                <el-col :span="12">

                    <div class="chart-container" ref="workChart"></div>

                </el-col>
                <!-- 第二个饼图：经济/非经济区 -->
                <el-col :span="12">

                    <div class="chart-container" ref="ecoChart"></div>

                </el-col>
            </el-row>
        </div>
        <div class="table-caption">图表3</div>
        <div class="note">
            <p>说明：非工作区表示发动机怠速、零负荷的工作范围，该区域中发动机不处于驱动车辆的状态。</p>
        </div>
        <!-- 横向多列表格（完全匹配截图） -->
        <div class="table-wrapper">
            <el-table :data="tableData" border :cell-style="cellStyle" :header-cell-style="headerCellStyle">
                <!-- 转速列（首列） -->
                <el-table-column label="转速-扭矩" prop="Title" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.Title == 'Total' ? "累计" : scope.row.Title }}
                    </template>
                </el-table-column>

                <!-- 扭矩列（横向表头） -->
                <!-- 速度区间列（横向表头） -->
                <el-table-column v-for="(speed, idx) in speedHeaders" :key="idx" :label="speed.title" :prop="speed.key"
                    align="center" width="42">
                    <template slot-scope="scope">
                        {{ scope.row[speed.key] || '0.00' }}
                    </template>
                </el-table-column>
                <!-- 累计列 -->
                <el-table-column label="累计" prop="累计" width="50" align="center" />
            </el-table>
        </div>
        <div class="table-caption">数据表3</div>

        <!-- 说明文本 -->
        <div class="note">
            <p>说明：发动机工作在经济转速范围内中等负荷工况下经济性较好，因此发动机工况分布在该区域内的比例越大、越集中车辆的燃耗经济性越好。</p>
        </div>
    </div>
</template>

<script>

export default {
    name: "VehicleEngineLoadRateData",
    props: {
        engineLoadChart: {
            type: Object,
            default: () => ({
                Chart: [],
                PieChart: []
            })
        }
    },
    watch: {
        engineLoadChart: {
            handler(newVal, oldVal) {
                if (newVal.Chart.length > 0) {
                    this.initTableChart();
                }
                if (newVal.PieChart) {
                    this.initWorkChart();
                    this.initEcoChart();
                }
            },
            deep: true
        }
    },
    data() {
        return {

            // 扭矩表头（横向列）
            speedHeaders: [

                { title: '≤10', key: 'B10' },
                { title: '≤20', key: 'B20' },
                { title: '≤30', key: 'B30' },
                { title: '≤40', key: 'B40' },
                { title: '≤50', key: 'B50' },
                { title: '≤60', key: 'B60' },
                { title: '≤70', key: 'B70' },
                { title: '≤80', key: 'B80' },
                { title: '≤90', key: 'B90' },
                { title: '≤95', key: 'B95' },
                { title: '>95', key: 'H95' },],
            // 表格数据：转速作为行，扭矩作为列
            tableData: [

            ]
        };
    },
    mounted() {

        // 监听窗口缩放
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        initTableChart() {
            
            const transposedData = this.transposeAndRenameAll(this.engineLoadChart.Chart);
            this.tableData = transposedData
            // console.log(JSON.stringify(transposedData, null, 2));
        },
        transposeData(data) {
            // 1. 获取所有列名（指标名：Title、Total、B700...）
            const keys = Object.keys(data[0]);
            // 2. 获取所有行标题（阈值：>95、≤95...累计）
            const rowTitles = data.map(item => item.Title);

            // 3. 遍历列名，构建转换后的数据
            const transposed = keys.filter(key => key !== 'Title').map(key => {
                const newItem = { Title: this.renameKey(key) }; // 新数据的Title为原列名
                // 为每个阈值（原行）赋值
                rowTitles.forEach((title, index) => {
                    newItem[title] = data[index][key];
                });
                return newItem;
            });

            return transposed;
        },
        transposeAndRenameAll(data) {
            // 1. 获取原始列名（指标名）和原始阈值标题
            const originalIndicators = Object.keys(data[0]);
            const originalThresholds = data.map(item => item.Title);

            // 2. 重命名阈值标题（用于新数据的列名）
            const renamedThresholds = originalThresholds.map(this.renameThreshold);

            // 3. 遍历原始指标名，构建转换后的数据（未调整Total位置）
            let transposedData = originalIndicators.filter(key => key !== 'Title').map(originalIndicator => {
                const newItem = {
                    Title: this.renameIndicator(originalIndicator) // 重命名后的指标名作为新Title
                };
                // 为每个重命名后的阈值列赋值
                renamedThresholds.forEach((threshold, index) => {
                    newItem[threshold] = data[index][originalIndicator];
                });
                return newItem;
            });

            // 4. 将Total行移至最后
            // 筛选出Total行和非Total行
            const totalRow = transposedData.find(item => item.Title === 'Total');
            const nonTotalRows = transposedData.filter(item => item.Title !== 'Total');
            // 重新拼接：非Total行 + Total行
            transposedData = [...nonTotalRows, totalRow];

            return transposedData;
        },
        /**
  * 重命名指标名（B700→≤700，H2400→>2400）
  * @param {string} key - 原始指标名
  * @returns {string} 重命名后的指标名
  */
        renameIndicator(key) {
            if (key.startsWith('B')) {
                const num = key.slice(1);
                return `≤${num}`;
            } else if (key === 'H2400') {
                return '>2400';
            }
            return key; // Title、Total 保持不变
        },

        /**
         * 重命名阈值标题（>95→H95，≤95→B95...≤10→B10，累计不变）
         * @param {string} title - 原始阈值标题
         * @returns {string} 重命名后的阈值标题
         */
        renameThreshold(title) {
            if (title === '>95') {
                return 'H95';
            } else if (title.startsWith('≤')) {
                const num = title.slice(1);
                return `B${num}`;
            }
            return title; // 累计保持不变
        },
        // 表头样式（转速行背景色）
        headerCellStyle({ columnIndex }) {
            if (columnIndex === 0) return { 'background-color': '#f5f7fa' }; // 扭矩列表头
            return { 'background-color': '#e6f7ff' }; // 转速列表头
        },
        // 单元格样式（背景色区分）
        cellStyle({ row, columnIndex }) {
            if (columnIndex === 0) return {};
            if (row['Title'] === 'Total') return {};
            const speedColKey = this.speedHeaders[columnIndex - 1]?.key;
            const cellValue = row[speedColKey] || '0.00';
            const value = Number(cellValue);

            if (value == 0) return { 'background-color': '#ffffff' };
            else if (value > 0 && value <= 0.05) return { 'background-color': '#FFEFDB' };
            else if (value > 0.05 && value <= 0.1) return { 'background-color': '#EEE5DE' };
            else if (value > 0.1 && value <= 0.2) return { 'background-color': '#FFE4B5' };
            else if (value > 0.2 && value <= 0.3) return { 'background-color': '#E0FFFF' };
            else if (value > 0.3 && value <= 0.4) return { 'background-color': '#BFEFFF' };
            else if (value > 0.4 && value <= 0.5) return { 'background-color': '#AEEEEE' };
            else if (value > 0.5 && value <= 1) return { 'background-color': '#8DEEEE' };
            else if (value > 1 && value <= 5) return { 'background-color': '#CD950C' };
            else if (value > 5 && value <= 10) return { 'background-color': '#EE7600' };
            else if (value > 10 && value <= 15) return { 'background-color': '#CD4F39' };
            else if (value > 15) return { 'background-color': '#FF0000' };

            return {};
        },

        initWorkChart() {
            const workChart = echarts.init(this.$refs.workChart);
            const option = {
                title: {
                    text: '发动机运行状态饼图',
                    left: 'center',
                    textStyle: { fontSize: 16 }
                },
                backgroundColor: '#e2f0ff',
                grid: {
                    left: '3%',

                    bottom: '8%',
                    right: '3%',

                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{b}: {c}%'
                },
                series: [
                    {
                        type: 'pie',


                        data: [
                            { value: this.engineLoadChart.PieChart.WorkPer, name: '工作区域', itemStyle: { color: '#409EFF' } },
                            { value: this.engineLoadChart.PieChart.NonWorkPer, name: '非工作区域', itemStyle: { color: '#d983c0' } }
                        ],
                        label: {
                            show: true,
                            position: 'inside',
                            formatter: '{b}: {c}%'
                        },
                        labelLine: { show: true }
                    }
                ]
            };
            workChart.setOption(option);
            this.$workChart = workChart;
        },

        // 初始化“经济/非经济区”饼图
        initEcoChart() {
            const ecoChart = echarts.init(this.$refs.ecoChart);
            const option = {
                title: {
                    text: '发动机工作状态饼图',
                    left: 'center',
                    textStyle: { fontSize: 16 }
                }, backgroundColor: '#e2f0ff',
                tooltip: {
                    trigger: 'item',
                    formatter: '{b}: {c}%'
                },
                series: [
                    {
                        type: 'pie',

                        data: [
                            { value: this.engineLoadChart.PieChart.EconPer, name: '经济区', itemStyle: { color: '#67C23A' } },
                            { value: this.engineLoadChart.PieChart.NonEconPer, name: '非经济区', itemStyle: { color: '#eae3b2' } }
                        ],
                        label: {
                            show: true,
                            position: 'inside',
                            formatter: '{b}: {c}%'
                        },
                        labelLine: { show: true }
                    }
                ]
            };
            ecoChart.setOption(option);
            this.$ecoChart = ecoChart;
        },

        // 窗口缩放时图表自适应
        handleResize() {
            this.$workChart?.resize();
            this.$ecoChart?.resize();
        },

        // 合并单元格方法

    }
};
</script>
<style scoped>
.chart-container {

    height: 280px;
    /* 图表高度 */
}
</style>